/**
 * Used by PaxFrameGroupingSystem. The component holds a list of grouped frames and
 * a prop that tells us if the group contains a corner solution frame.
 */
class FrameGroupComponent {
    constructor(frames, cornerSolution) {
        this.typeId = FrameGroupComponent.id;
        this.doStoreInSnapshot = true;
        this.serializable = false;
        this.frames = [];
        this.cornerSolution = false;
        this.frames = frames;
        this.cornerSolution = cornerSolution;
    }
    eq(other) {
        return (JSON.stringify(this.frames.map(f => f.id)) === JSON.stringify(other.frames.map(f => f.id)));
    }
}
FrameGroupComponent.id = 2082;
export default FrameGroupComponent;
//# sourceMappingURL=FrameGroupComponent.js.map